import("owl.carousel");

function addAriaLabel(event) {
    $('.owl-dots button').each(function (index) {
        //Add arial-lable to the dots
        $(this).attr('aria-label', "Next Slide");
    });
}

$(".carousel__homepage").owlCarousel({
    loop: true,
    dots: true,
    items: 1,
    autoplay: true,
    smartSpeed: 2000,
    navElement: "div",
    onInitialized: addAriaLabel,
    onResized: addAriaLabel
});

$(".carousel__usp").owlCarousel({
    margin: 0,
    nav: false,
    dots: false,
    autoplay: true,
    navSpeed: 1000,
    touchDrag: false,
    mouseDrag: false,
    animateOut: "fadeOut",
    animateIn: "fadeIn",
    autoplayTimeout: 5000,
    autoplayHoverPause: false,
    responsive: {
        0: {
            loop: true,
            items: 1
        },
        992: {
            loop: false,
            items: 6,
            autoWidth: true
        }
    }
});

$(".client-images").owlCarousel({
    loop: true,
    autoplay: true,
    nav: false,
    thumbs: true,
    thumbsPrerendered: true,
    thumbContainerClass: "owl-thumbs",
    thumbItemClass: "owl-thumb-item",
    responsive: {
        0: {
            loop: true,
            items: 2
        },
        992: {
            loop: true,
            items: 7,
        }
    }
});

$(".category_slider").owlCarousel({
    mouseDrag: false,
    loop: $('.owl-carousel .category-item').length > 4 ? true : false,
    items: 4,
    autoplay: false,
    nav: true,
    navText: false,
    dots: false,
});

function owlInitialize() {
    if ($(window).width() < 992) {
        $(".carousel__products").owlCarousel({
            margin: 10,
            dots: false,
            items: 4,
            stagePadding: 60,
            responsive: {
                0: {
                    items: 1,
                    loop: true,
                },
                568: {
                    items: 2,
                    loop: true
                }
            }
        });
    } else {
        $(".owl-carousel.carousel__products").owlCarousel("destroy");
    }
}

$(document).ready(function () {
    owlInitialize();
});
$(window).resize(function () {
    owlInitialize();
});
